// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.

// Passwords are encrypted with the server's RSA public key. Only the server
// holds the matching private key, so nothing secret ships in this bundle.

const PUBLIC_KEY_B64 = process.env.REACT_APP_PASSWORD_PUBLIC_KEY;

let cachedKey = null;

function base64ToArrayBuffer(b64) {
  const binary = window.atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

// Strips the PEM armour and returns the raw SPKI bytes.
function pemToSpki(pem) {
  const body = pem
    .replace(/-----BEGIN PUBLIC KEY-----/, "")
    .replace(/-----END PUBLIC KEY-----/, "")
    .replace(/\s+/g, "");
  return base64ToArrayBuffer(body);
}

async function getPublicKey() {
  if (cachedKey) return cachedKey;

  if (!PUBLIC_KEY_B64) {
    throw new Error("REACT_APP_PASSWORD_PUBLIC_KEY is not configured");
  }

  // The env var holds the base64 of the whole PEM so it survives .env and
  // Docker ENV as a single line.
  const pem = window.atob(PUBLIC_KEY_B64);

  cachedKey = await window.crypto.subtle.importKey(
    "spki",
    pemToSpki(pem),
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"],
  );

  return cachedKey;
}

export async function encryptPassword(plainPassword) {
  const key = await getPublicKey();
  const encrypted = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    key,
    new TextEncoder().encode(plainPassword),
  );
  return arrayBufferToBase64(encrypted);
}
